import React, { useState } from "react";
import { Tabs, Tab, Spinner, Alert } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import SelectorCuenta from "../../components/SelectorCuenta";
import useCuentasCliente from "../../hooks/useCuentasCliente";
import GastosFijos from "./GastosFijos";
import GastosEsporadicos from "./GastosEsporadicos";

/**
 * Ventana de "Gastos": pestaña de Gastos Fijos (con checkbox de pagado que
 * descuenta el saldo) y pestaña de Gastos Esporádicos (alta rápida). La pestaña
 * inicial se puede indicar por URL (ej. /gastos?tab=esporadicos), para que las
 * tarjetas del Dashboard puedan llevar directo a la que corresponda.
 */
export default function GastosPage() {
  const { cuentas, cuentaId, setCuentaId, cargando, recargar } = useCuentasCliente();
  const onSaldoCambiado = () => recargar(false);
  const [searchParams] = useSearchParams();
  const tabInicial = searchParams.get("tab") === "esporadicos" ? "esporadicos" : "fijos";
  const [tab, setTab] = useState(tabInicial);

  if (cargando) return <Spinner animation="border" />;
  if (!cuentas.length) {
    return <Alert variant="info">Primero crea una cuenta bancaria en el módulo "Cuentas Bancarias".</Alert>;
  }

  return (
    <div>
      <h4 className="mb-3">Gastos</h4>
      <SelectorCuenta cuentas={cuentas} cuentaId={cuentaId} onChange={setCuentaId} />

      <Tabs activeKey={tab} onSelect={(k) => setTab(k)} className="mb-3">
        <Tab eventKey="fijos" title="Gastos Fijos">
          <GastosFijos cuentaId={cuentaId} cuentas={cuentas} onSaldoCambiado={onSaldoCambiado} />
        </Tab>
        <Tab eventKey="esporadicos" title="Gastos Esporádicos">
          <GastosEsporadicos cuentaId={cuentaId} cuentas={cuentas} onSaldoCambiado={onSaldoCambiado} />
        </Tab>
      </Tabs>
    </div>
  );
}
